export const BASE_URL = '/api'
export const EPP_CONTACT = BASE_URL + '/epp/contact'
export const SEARCH_CONTACT = BASE_URL + '/epp/contact'
export const REGISTRY_CONTACTS = BASE_URL + '/registry/contacts'
export const REGISTRY_COUNTRIES = BASE_URL + '/registry/countries'
